import axios from 'axios';

export const axiosGet = (urlApi, params) => axios.get(urlApi, params);
